import type { CalendarProvider, CalendarSnapshot } from './calendar-types';

export type SlotVerdict = { kind: 'ok'; providerId: string } | { kind: 'outside_session' } | { kind: 'blocked' } | { kind: 'past' };

function covers(from: string, to: string, at: number): boolean {
  return at >= Date.parse(from) && at < Date.parse(to);
}

function inSession(provider: CalendarProvider, date: string, at: number): boolean {
  return provider.sessions.some((session) => session.date === date && covers(session.startsAt, session.endsAt, at));
}

function onLeave(provider: CalendarProvider, at: number): boolean {
  return provider.blocks.some((block) => covers(block.startsAt, block.endsAt, at));
}

export function slotVerdict(
  snapshot: Pick<CalendarSnapshot, 'days' | 'providers'>,
  providerIds: readonly string[],
  dayIndex: number,
  slotAtIso: string,
  nowMs: number,
): SlotVerdict {
  const day = snapshot.days[dayIndex];
  if (!day) return { kind: 'outside_session' };
  const at = Date.parse(slotAtIso);
  const candidates = providerIds
    .map((id) => snapshot.providers.find((provider) => provider.id === id))
    .filter((provider): provider is CalendarProvider => provider !== undefined)
    .filter((provider) => inSession(provider, day.date, at));
  if (candidates.length === 0) return { kind: 'outside_session' };
  const free = candidates.find((provider) => !onLeave(provider, at));
  if (!free) return { kind: 'blocked' };
  if (at < nowMs) return { kind: 'past' };
  return { kind: 'ok', providerId: free.id };
}
